<template>
  <div id="default">
    <el-container>
      <OAMenu :class="{menuOpen:isCollapse}" v-if="leftAsideShow"></OAMenu>
      <el-container :class="{closeSide:isCollapse,noSide:!leftAsideShow}">
        <el-header v-if="leftAsideShow">
          <OAHeader></OAHeader>
        </el-header>
        <el-main :class="leftAsideShow?'':'main-container'">
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import OAHeader from "@/components/OAheader/OAheader";
import OAMenu from "@/components/OAMenu/OAMenu";
import store from "@/store";

export default {
  name: "home",
  components: { OAHeader, OAMenu },
  computed: {
    leftAsideShow() {
      return store.getters.leftAsideShow;
    },
    isCollapse() {
      return store.getters.isCollapse;
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/pages/default/default.vue